<div fxLayout="row" fxLayoutAlign="space-between center">
  <div fxLayout="column" fxFlex="100">
    {{applicationDetails.appName}} &copy; {{currentYear}}
  </div>
  <div fxLayout="column">
    v{{applicationDetails.version}}
  </div>
</div>
